import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Tooltip, Typography } from '@mui/material';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { PlanInclusionProps as Props } from './types';

const TOOLTIP_POPPER_PROPS = {
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: [120, -10],
      },
    },
  ],
};

export const PlanInclusion = memo(({ className }: Props) => {
  const { isPaid, config } = usePlanCardContext();
  const { features, featuresDescription } = config;

  return (
    <Styled.Wrapper
      className={classnames('PlanInclusion', className)}
      sx={SX.root}
      gap={1}
    >
      {features?.map((feature, index) => (
        <Box key={index} display="flex" alignItems="center" gap={0.5}>
          <Tooltip
            title={featuresDescription[index] || ''}
            placement="top"
            PopperProps={TOOLTIP_POPPER_PROPS}
          >
            <Icon
              size={16}
              name="info"
              sxx={SX.icon({
                isUsageBased: isPaid,
                disabled: feature.disabled,
              })}
              color={
                feature.disabled
                  ? 'grey.300'
                  : isPaid
                  ? 'common.white'
                  : 'grey.400'
              }
            />
          </Tooltip>
          <Typography
            variant="body4"
            fontWeight={700}
            color={
              feature.disabled
                ? 'grey.300'
                : isPaid
                ? 'common.white'
                : 'common.black'
            }
          >
            {feature.title}
          </Typography>
        </Box>
      ))}
    </Styled.Wrapper>
  );
});

PlanInclusion.displayName = 'PlanInclusion';
